import { useMutation } from '@tanstack/react-query';
import { LoyaltyApiError } from '~/lib/data-contract/loyalty';
import { useQueryClient } from '@tanstack/react-query';
import { MutationKeys, QueryKeys, ScopedMutationKeys } from '~/services/loyalty/constants';
import useBasket from '~/features/commerce-api/hooks/useBasket';
import { useLoyaltyContext } from '../useLoyaltyContext';

export const useAddRewardToBasket = () => {
    const { businessCentralId } = useLoyaltyContext();
    const queryClient = useQueryClient();
    const basket = useBasket();

    type ReserveRewardPayload = {
        rewardCode: string;
        amount: number;
    };

    return useMutation<void, LoyaltyApiError, ReserveRewardPayload>({
        mutationKey: [MutationKeys.ADD_REWARD],
        mutationFn: async ({ rewardCode, amount }) => {
            await basket.addRewardPayment(amount, {
                memberAccountNo: businessCentralId,
                barcode: rewardCode,
            });
        },

        // scope is to ensure that the mutation runs in serial instead of parallel to
        // ensure full sync between FE and SFCC when adding a bonusReward
        scope: {
            id: ScopedMutationKeys.SCOPED_REWARDS,
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [QueryKeys.ACTIVE_MEMBER_REWARDS],
            });
        },
    });
};
